




















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SExpandable extends Vue {
  @Prop({ type: Boolean, default: false }) private defaultExpanded!: boolean;
  @Prop({ type: Boolean, default: false }) private expandAsShow!: boolean;
  @Prop({ type: String, required: true }) private title!: boolean;
  private expanded = this.defaultExpanded;

  private toggleExpanded(): void {
    this.expanded = !this.expanded;
  }
}
